import { render, staticRenderFns } from "./RoleCardsBlock.vue?vue&type=template&id=04b3137b"
import script from "./RoleCardsBlock.vue?vue&type=script&lang=js"
export * from "./RoleCardsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports